import { Skeleton } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { openTaskAction } from '../../../../../redux/tasks/actions.js';
import { getOpenedTaskParentTaskId, getOpenedTaskParentTaskTitle, getOpenedTaskParentTaskTitleIdentifier } from '../../../../../redux/tasks/taskEntities/selectors.js';

const ParentTaskBreadCrumbs = ({ parentTaskId, parentTaskTitle, parentTaskTitleIdentifier }) => {
  const dispatch = useDispatch();

  const [showBreadCrumb, setShowBreadCrumb] = useState(!!parentTaskId);

  useEffect(() => {
    setShowBreadCrumb(!!parentTaskId)
  }, [parentTaskId]);

  const handleParentTaskOpen = useCallback(() => {
    if (!parentTaskTitleIdentifier) return;

    dispatch(openTaskAction(true, parentTaskTitleIdentifier, parentTaskId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentTaskId, parentTaskTitleIdentifier]);

  return !showBreadCrumb ? null : (
    <div
      className="h-9 bg-blue-500 flex align-center text-white px-5 cursor-pointer sticky top-0 z-[10]"
      onClick={handleParentTaskOpen}
    >
      {'>'}
      {parentTaskTitle ? (
        <span className="hover:text-sky-300 ml-2 underline truncate">
          {parentTaskTitle}
        </span>
      ) : (
        <Skeleton className="ml-2" variant="text" height={20} width={140} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    parentTaskId: getOpenedTaskParentTaskId(state),
    parentTaskTitle: getOpenedTaskParentTaskTitle(state),
    parentTaskTitleIdentifier: getOpenedTaskParentTaskTitleIdentifier(state),
  };
}

export default connect(mapStateToProps)(ParentTaskBreadCrumbs);
